module.exports = __webpack_public_path__ + "img/ci.93b5ef58.jpg";